import CompLayout from "@/pcomponents/comp/layout/layout";
import MoveButtonArea from "@/pages/comp/plan/coolen/common/move_btn_area";

function CoolenMovePage() {

  return (
    <CompLayout isConTitle={false}>
      <MoveButtonArea></MoveButtonArea>
    </CompLayout>
  );
};
export default CoolenMovePage;